import { AttachmentTypes } from 'types/api';
import { Attachment } from 'types/clients';

const getLatestAttachmentOfType = (
  attachments: Attachment<AttachmentTypes>[] | null | undefined,
  type: AttachmentTypes
): Attachment<AttachmentTypes> | null => {
  if (!attachments) {
    return null;
  }

  const attachmentsOfType = attachments.filter(
    (attachment) => attachment.type === type
  );

  if (attachmentsOfType.length === 0) {
    return null;
  }

  const sorted = attachmentsOfType.sort((a, b) => {
    return +new Date(b.createdDate) - +new Date(a.createdDate);
  });

  return sorted[0];
};

export { getLatestAttachmentOfType };
